import { CommonModule } from '@angular/common';
import { NgModule, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LazyDialogLoader } from './services';

@NgModule({
  imports: [CommonModule, MatDialogModule],
  providers: [{ provide: MatDialogRef, useValue: {} }, LazyDialogLoader],
})
export class DialogLoaderModule {
  private dialogLoader = inject(LazyDialogLoader);

  constructor() {
    const dialogLoader = this.dialogLoader;

    // preload components that are required on app start, be aware to load any bulky components, only strongly required
    dialogLoader.preloadDialog('alert');
  }
}
